import React from "react";
import { useNavigate } from "react-router-dom";
import "./FailedPage.css";

const FailedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="failed-container">
      <div className="failed-box">
        {/* Animated Cross Icon */}
        <div className="icon-wrapper">
          <svg className="cross-icon" viewBox="0 0 100 100">
            <circle className="circle" cx="50" cy="50" r="45" fill="none" />
            <line className="line line1" x1="35" y1="35" x2="65" y2="65" />
            <line className="line line2" x1="65" y1="35" x2="35" y2="65" />
          </svg>
        </div>

        <h1 className="failed-title">Booking Unsuccessful</h1>

        <p className="failed-text">
          Something went wrong while processing your request. Don't worry, if
          any amount was deducted, it will be refunded automatically within 5-7
          business days.
        </p>
        <p className="failed-reason">
          <strong>Error Reason:</strong>: (e.g., Payment declined by bank /
          Seats no longer available).
        </p>
        <p className="failed-action">
          <strong>Action Steps:</strong>Please check your internet connection or
          try a different payment method.
        </p>
        <div className="failed-btn-div">
          <button
            className="retry-btn"
            onClick={() => navigate("/book-now-info")}
          >
            Try Again
          </button>
          <button className="retry-btn" onClick={() => navigate("/")}>
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default FailedPage;
